import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Purpose } from 'src/app/enums/purpose';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { StartupService } from 'src/app/services/startup.service';
import { ThreeDService } from 'src/app/services/three-d.service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit, AfterViewInit {
  purpose: Purpose;
  constructor(
    private configurationService: ConfigurationService,
    private startUpService: StartupService,
    private threeDService: ThreeDService
  ) {}
  purposes = Purpose;
  ngOnInit() {
    this.threeDService.setZoom(5);
    this.threeDService.resetDefaultCamera(true);
    this.configurationService.furthestStepVisited = 1;

    this.startUpService.initialized$.subscribe(() => {
      this.purpose = this.configurationService.purpose;
    });
  }

  ngAfterViewInit() {
    this.configurationService.purpose = this.purpose;
  }

  setPurpose(purpose: Purpose) {
    this.purpose = purpose;
    this.configurationService.purpose = this.purpose;
  }
}
